import { CountryEnum } from "Infrastructure/Api/Api";
import { z } from "zod";
import { buildingNumberSchema } from "./common";

export const partnerBillingAddressSchema = () => {
	return z.object({
		id: z.number().nullish(),
		street: z.string().nullish(),
		buildingNumber: buildingNumberSchema(10),
		postCode: z.string().nullish(),
		city: z.string().nullish(),
		country: z.nativeEnum(CountryEnum).nullish(),
	});
};

export type PartnerBillingAddressFormModel = z.infer<
	ReturnType<typeof partnerBillingAddressSchema>
>;
